import { combineReducers } from '@reduxjs/toolkit';

import app from 'components/app/_mediator/app.slice';
import app__data from 'components/app/_mediator/app-data.slice';
import app__files from 'components/app/_mediator/app-files.slice';
import app__logger from 'components/app/_mediator/app-logger.slice';
import app__filesUpload from 'components/app/_mediator/app-files-upload.slice';
import clipThumb from 'components/app/_mediator/clip-thumb/clip-thumb.slice';
import memory from 'components/app/_mediator/memory/memory.slice';
import projects from 'components/app/projects/_mediator/projects.slice';
import audio from 'components/app/audio-track/_mediator/audio-track.slice';
import editor from 'components/app/editor/_mediator/editor.slice';
import editor__actions from 'components/app/editor/_mediator/editor-actions.slice';
import editor__controls from 'components/app/editor/_mediator/editor-controls.slice';
import monitorReq from 'components/app/editor/_mediator/monitor/monitor-req.slice';
import monitor from 'components/app/editor/_mediator/monitor/monitor.slice';
import backup from 'components/app/editor/_mediator/backup/backup.slice';
import timestamp from 'components/app/editor/timestamp/_mediator/timestamp.slice';
import selector from 'components/app/selector/_mediator/selector.slice';
import sb from 'components/app/storyboard/_mediator/sb.slice';
import sb__player from 'components/app/storyboard/sb-player/_mediator/sb-player.slice';
import fc__data from 'components/app/finalcuts/_mediator/fc-data.slice';
import fc__controls from 'components/app/finalcuts/_mediator/fc-controls.slice';
import fc__renderServer from 'components/app/finalcuts/_mediator/fc-render-server.slice';
import pp from 'components/app/playground/player/_mediator/pp.slice';
import highlights from 'components/app/highlights/_mediator/highlights.slice';

export const reducers = combineReducers({
  app,
  app__data,
  app__files,
  app__logger,
  app__filesUpload,
  projects,
  memory,
  editor,
  editor__controls,
  editor__actions,
  monitor,
  monitorReq,
  backup,
  timestamp,
  clipThumb,
  audio,
  selector,
  sb,
  sb__player,
  fc__data,
  fc__controls,
  fc__renderServer,
  pp,
  highlights,
});
